import { Grid, Paper, Typography } from '@material-ui/core';
import cs from 'classnames';
import Header from 'components/Header/Header';
import { loadV2ProviderConfig } from 'components/TrustCenter/store/actions';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import * as Constants from 'constants/Constants';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { MACROPOINT } from '../../../store/actions/types';
import Styles from '../../ProviderDetail.module.css';
import CarrierConfig from './CarrierConfig';

export const toCarrierConfigType = (name) => {
    const normalized = String(name || '')
        .replace(/[\s_-]/g, '')
        .toLowerCase();
    if (normalized === 'fourkites') {
        return Constants.FOURKITES;
    }
    if (normalized === 'macropoint') {
        return MACROPOINT;
    }
    return null;
};

export const resolveCarrierConfigType = ({ displayName, configName, agreementName } = {}) =>
    toCarrierConfigType(displayName) ||
    toCarrierConfigType(configName) ||
    toCarrierConfigType(agreementName);

const CarrierConfigPage = ({ history, location, match, providerConfigV2, loadProviderConfig }) => {
    const providerAccountId = match?.params?.providerAccountId;
    const typeFromState = toCarrierConfigType(
        location?.state?.carrierConfigType || location?.state?.providerName
    );
    const providerFromConfig = providerConfigV2?.find(
        (provider) => provider.providerAccountId === providerAccountId
    );
    const type = typeFromState || toCarrierConfigType(providerFromConfig?.providerName);
    const [lookupFinished, setLookupFinished] = useState(Boolean(type));

    useEffect(() => {
        if (type) {
            setLookupFinished(true);
            return undefined;
        }
        let active = true;
        loadProviderConfig().finally(() => {
            if (active) {
                setLookupFinished(true);
            }
        });
        return () => {
            active = false;
        };
    }, [providerAccountId, type, loadProviderConfig]);

    const backToAgreements = () => {
        const providerName = location?.state?.providerName || providerFromConfig?.providerName;
        history.push({
            pathname: `/connections/v2/provider/${providerAccountId}`,
            search: location.search || '',
            ...(providerName ? { state: { providerName } } : {})
        });
    };

    return (
        <>
            <Header title="CARRIER CONFIG" />
            <Paper className={Styles.customToolBar}>
                <div className={cs('row no-gutters', baseCSS.subHeader)}>
                    <Grid container>
                        <Grid item xs={12}>
                            <div className={baseCSS.backNavigation}>
                                <Typography
                                    onClick={backToAgreements}
                                    className={baseCSS.backNavigation}
                                >
                                    <i
                                        className={cs(
                                            'fas fa-arrow-left',
                                            baseCSS.backNavigationIcon
                                        )}
                                    />
                                    Back to Sharing Agreements
                                </Typography>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Paper>
            <div className="col-sm-12" style={{ padding: '30px 50px 10px 50px' }}>
                <Paper className={Styles.baseMargin} elevation={3}>
                    {type ? (
                        <div className="row">
                            <CarrierConfig type={type} />
                        </div>
                    ) : lookupFinished ? (
                        <div className="row">
                            <div className="col-sm-12" style={{ padding: '20px' }}>
                                Carrier config is available for FourKites and MacroPoint.
                            </div>
                        </div>
                    ) : null}
                </Paper>
            </div>
        </>
    );
};

const mapStateToProps = (state) => ({
    providerConfigV2: state.agreementV2.providerConfig
});

export default withRouter(
    connect(mapStateToProps, { loadProviderConfig: loadV2ProviderConfig })(CarrierConfigPage)
);
